import { styled, css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const ChartWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const EmptyState = styled.p`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDarkAlpha50};
    text-align: center;
  `}
`;
